import { useTranslation } from 'react-i18next'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'

import { type Move } from '../../../modules/moves'
import { QuotesView } from './quotesView.types'

type QuotesViewsDropdownProps = {
  quotesView: QuotesView
  setQuotesView: (value: QuotesView) => void
  move: Move
}

const QuotesViewsDropdown: React.FC<QuotesViewsDropdownProps> = ({
  quotesView,
  setQuotesView,
  move,
}) => {
  const { t } = useTranslation()
  const { isLongDistance } = move.state

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuotesView(event.target.value as QuotesView)
  }

  return (
    <div className="flex w-full flex-wrap items-center justify-center gap-3 md:justify-end">
      <div className="whitespace-nowrap font-sans text-neutral-500">
        { t('quotes.filters.sortBy') }
      </div>

      <TextField
        value={quotesView}
        onChange={onChange}
        size="small"
        select
      >
        { isLongDistance && (
          <MenuItem
            value={QuotesView.best}
          >
            <div className="font-sans text-sm">
              { t('quotes.filters.views.bestLongDistance') }
            </div>
          </MenuItem>
        ) }

        { !isLongDistance && (
          <MenuItem
            value={QuotesView.cheapest}
          >
            <div className="font-sans text-sm">
              { t('quotes.filters.views.cheapest') }
            </div>
          </MenuItem>
        ) }

        { !isLongDistance && (
          <MenuItem
            value={QuotesView.best}
          >
            <div className="font-sans text-sm">
              { t('quotes.filters.views.best') }
            </div>
          </MenuItem>
        ) }

        <MenuItem
          value={QuotesView.bestRated}
        >
          <div className="font-sans text-sm">
            { t('quotes.filters.views.bestRated') }
          </div>
        </MenuItem>
      </TextField>
    </div>
  )
}

export default QuotesViewsDropdown
